import { useState } from "react";
import Swal from "sweetalert2";
import { SweetAlertShow } from "../../master/Master";
import { studentFeeTransactionReceiptNoUpdate } from "../../../api/Student";

export default function ReceiptNoUpdateModal({
  transaction,
  onClose,
  onUpdated,
}) {
  const [receiptNo, setReceiptNo] = useState(transaction?.receipt_no || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleUpdate = async () => {
    const value = receiptNo.trim();

    if (!value) {
      setError("Receipt No is required.");
      return;
    }

    setError("");

    const confirm = await Swal.fire({
      title: "Update Receipt No?",
      html: `
        <p>Current Receipt No:
          <strong>${transaction?.receipt_no || "-"}</strong>
        </p>
        <p>New Receipt No:
          <strong>${value}</strong>
        </p>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!confirm.isConfirmed) return;

    setSaving(true);

    try {
      const response = await studentFeeTransactionReceiptNoUpdate({
        transaction_id: transaction?.id,
        receipt_no: value,
      });

      if (response?.data?.status) {
        SweetAlertShow(
          "success",
          "Successfully",
          response?.data?.message || "Receipt No updated successfully.",
        );

        onUpdated?.(response?.data);
        onClose?.();
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Unable to update Receipt No.",
        );
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ||
          error?.response?.message ||
          error?.message ||
          "Something went wrong.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="modal d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
      tabIndex={-1}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content rounded-4 border-0">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">
              <i className="ri-edit-line text-primary me-2"></i>
              Update Receipt No
            </h5>

            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={saving}
            />
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Current Receipt No
              </label>

              <input
                type="text"
                className="form-control"
                value={transaction?.receipt_no || "-"}
                disabled
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">
                New Receipt No <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                className={`form-control ${error ? "is-invalid" : ""}`}
                value={receiptNo}
                onChange={(e) => {
                  setReceiptNo(e.target.value);
                  setError("");
                }}
                placeholder="Enter new receipt no"
                disabled={saving}
              />

              {error && <div className="invalid-feedback">{error}</div>}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleUpdate}
              disabled={saving}
            >
              {saving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Updating...
                </>
              ) : (
                <>
                  <i className="ri-save-line me-1"></i>
                  Update Receipt
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
